import React from 'react';
import { Components } from './styled';
import { getMonthFromDate, parseDateToStringWithFormat } from '../../../utils/dateFormat';
import { Value, LooseValue, Detail, TileArgs } from 'react-calendar/src/shared/types';
import DayEvents from './tiles/DayEvents';
import { ProjectCalendarNavigationType, ProjectCalendarType } from './types';
import { ReactComponent as ArrowLeft } from '../../../assets/icons/icon-arrow-left-alt.svg';
import { ReactComponent as ArrowRight } from '../../../assets/icons/icon-arrow-right-alt.svg';
import { format } from '../../../utils/dateFormat/types';

const TileContent = ({ date, view, hasDailyAlux }: { date: Date; view: Detail; hasDailyAlux?: boolean }) => {
  switch (view) {
    case 'month':
      return <DayEvents date={date} hasDailyAlux={hasDailyAlux} />;
    case 'year':
      return <span>{getMonthFromDate(date)}</span>;
  }
  return null;
};

const ProjectCalendar = ({
  calendarConfig,
}: {
  calendarConfig: {
    value?: LooseValue;
    events?: any;
    onValueChange?: (value: Date | null) => void;
    onValuesChange?: (value: Date[]) => void;
    variant: ProjectCalendarType;
    activeStartDate?: Date;
    navigationType?: ProjectCalendarNavigationType;
    onPreviousPress?: () => void;
    onNextPress?: () => void;
    selectRange?: boolean;
    minDate?: Date;
    maxDate?: Date;
  };
}) => {
  const {
    value,
    events,
    onValueChange,
    onValuesChange,
    variant,
    activeStartDate,
    navigationType,
    onPreviousPress,
    onNextPress,
    selectRange,
    minDate,
    maxDate,
  } = calendarConfig;
  const calendarTitle =
    value && navigationType === 'custom' && parseDateToStringWithFormat(value as Date, format.monthYear);

  const getUtcDate = (value: Value): Date => {
    const valueDate = value as Date;
    return new Date(Date.UTC(valueDate.getFullYear(), valueDate.getMonth(), valueDate.getDate()));
  };

  const _onValueChange = (value: Value) => {
    if (onValueChange) {
      onValueChange?.(value ? getUtcDate(value) : null);
    }
    if (onValuesChange) {
      onValuesChange?.(value && Array.isArray(value) ? value.map((item) => getUtcDate(item)) : []);
    }
  };

  const _onPreviousMonthPress = () => {
    onPreviousPress?.();
  };
  const _onNextMonthPress = () => {
    onNextPress?.();
  };

  return (
    <Components.CalendarWrapper>
      {value && navigationType === 'custom' && (
        <Components.CustomHeader>
          <Components.CustomHeaderTitle>{calendarTitle}</Components.CustomHeaderTitle>
          {onPreviousPress && (
            <Components.CustomHeaderArrowWrapper onClick={_onPreviousMonthPress}>
              <ArrowLeft />
            </Components.CustomHeaderArrowWrapper>
          )}
          {onNextPress && (
            <Components.CustomHeaderArrowWrapper onClick={_onNextMonthPress}>
              <ArrowRight />
            </Components.CustomHeaderArrowWrapper>
          )}
        </Components.CustomHeader>
      )}
      <Components.Calendar
        value={value}
        onChange={_onValueChange}
        {...(activeStartDate && { activeStartDate })}
        selectRange={selectRange}
        allowPartialRange={selectRange}
        locale={'en'}
        variant={variant}
        prev2Label={null}
        next2Label={null}
        minDetail={'year'}
        minDate={minDate}
        maxDate={maxDate}
        showNavigation={navigationType === 'default'}
        {...(variant === 'dailyAlux' && {
          tileContent: ({ date, view }: TileArgs) => <TileContent date={date} view={view} hasDailyAlux={true} />,
        })}
        formatShortWeekday={(locale, date) => parseDateToStringWithFormat(date, 'EEEEE')}
      />
    </Components.CalendarWrapper>
  );
};

export default ProjectCalendar;
